import PropTypes from 'prop-types'
import Table from 'components/table/Table'
import { fixActionText } from 'features/editlog/editlogUtils'
import { useSelector } from 'react-redux'

const DetailCommon = ({ hierarchy, actionTypes, children }) => {
  const { name } = useSelector(state => state.account.current)
  return (
    <>
      <p className="subtit_layer">대상</p>
      <Table className="tbl_layer" caption="변경이력 대상 안내 표">
        <Table.Head noHead>
          <Table.Column width={161} />
          <Table.Column />
        </Table.Head>
        <Table.Body>
          {!Object.keys(hierarchy).length && (
            <Table.Row>
              <th scope="row">광고계정</th>
              <td>
                <div className="inner_cell">{name}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.ADACCOUNT && (
            <Table.Row>
              <th scope="row">광고계정</th>
              <td>
                <div className="inner_cell">{hierarchy.ADACCOUNT}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.BIZCHANNEL && (
            <Table.Row>
              <th scope="row">비즈채널</th>
              <td>
                <div className="inner_cell">{hierarchy.BIZCHANNEL}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.CAMPAIGN && (
            <Table.Row>
              <th scope="row">캠페인</th>
              <td>
                <div className="inner_cell">{hierarchy.CAMPAIGN}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.ADGROUP && (
            <Table.Row>
              <th scope="row">광고그룹</th>
              <td>
                <div className="inner_cell">{hierarchy.ADGROUP}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.KEYWORD && (
            <Table.Row>
              <th scope="row">키워드</th>
              <td>
                <div className="inner_cell">{hierarchy.KEYWORD}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.CREATIVE && (
            <Table.Row>
              <th scope="row">소재</th>
              <td>
                <div className="inner_cell">{hierarchy.CREATIVE}</div>
              </td>
            </Table.Row>
          )}
          {hierarchy?.CREATIVE_LINK && (
            <Table.Row>
              <th scope="row">소재</th>
              <td>
                <div className="inner_cell">{hierarchy.CREATIVE_LINK}</div>
              </td>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
      <p className="subtit_layer">항목</p>
      <table className="tbl_layer">
        <caption className="hide_caption">변경이력 항목 안내 표</caption>
        <colgroup>
          <col style={{ width: 161 }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">항목</th>
            <td>
              <div className="inner_cell">
                <span className="txt_limit">{fixActionText(actionTypes)}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {children}
    </>
  )
}

export default DetailCommon

DetailCommon.propTypes = {
  hierarchy: PropTypes.object,
  actionTypes: PropTypes.string,
  children: PropTypes.node,
}
